module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/AmwayIcons.svg?5v2gxx
// module id = Z1gp
// module chunks = 0